
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
(function () {

  // 変数
  var rul = {};
  var msg = {};
  var glp = {};

  glp['cond_price'] = 'cond_price_min cond_price_max';
  glp['contact_purpose'] = String.prototype.concat(
    'contact_purpose[1] ',
    'contact_purpose[2] ',
    'contact_purpose[3]'
  );

  // グローバル変数　※先にjs/validation/common.jsを読み込んでおく
  var getMsg = window.ohValidateGetMsg;
  var changeBlank = window.ohValidateChangeBlank;
  var changeHankaku = window.ohValidateChangehankaku;

  // // checkbox サンプル
  // // minlength: 2 → 少なくとも2つはチェック
  // rul['contact_purpose[]'] = {required: true, minlength: 1,};
  // msg['contact_purpose[]'] = {
  //   required:getMsg('required_without_all','お問い合わせ内容の選択'),
  //   minlength:getMsg('required_without_all','お問い合わせ内容の選択'),
  // };

  // checkbox サンプル
  // nameがcontact_purpose[1],contact_purpose[2]のように共通でない場合
  // rul['contact_purpose[1]'] = {
  //   required: {
  //     depends:function(){
  //       return $('input[name^=contact_purpose]:checked').length < 1;
  //   }},
  //   min: {
  //     param: 1,
  //     depends:function(){
  //       return $('input[name^=contact_purpose]:checked').length;
  //   }}
  // };
  // msg['contact_purpose[1]'] = {
  //   required:getMsg('required_without_all','お問い合わせ内容の選択'),
  //   min:getMsg('required_without_all','お問い合わせ内容の選択'),
  // };



  // お名前
  rul['customer_nm'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    maxlength: 40
  };
  msg['customer_nm'] = {
    required:getMsg('required','名前'),
    maxlength:getMsg('max.string', '名前', {'max' : '40'}),
  };

  // ふりがな
  rul['customer_kn'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }},
    kana: true,
    maxlength: 40
  };
  msg['customer_kn'] = {
    required:getMsg('required','ふりがな'),
    kana:getMsg('kana2'),
    maxlength:getMsg('max.string', 'ふりがな', {'max' : '40'})
  };

  // ご希望のご連絡方法
  // 正規表現
  rul['contact_way[]'] = {regex: '^1$',};
  msg['contact_way[]'] = {
    regex:getMsg('in'),
  };

  // トリム,空白,半角に自動変換
  // 電話番号
  rul['customer_tel_no'] = {
    required: {
      depends:function(){
        $(this).val($.trim($(this).val()));
        $(this).val(changeBlank($(this).val()));
        $(this).val(changeHankaku($(this).val()));
        return true;
      }
    },
    regex: '^(0{1}\\d{1,4}-{0,1}\\d{1,4}-{0,1}\\d{1,4})$',
    maxlength: 13
  };
  msg['customer_tel_no'] = {
    required:getMsg('required','電話番号',),
    regex:getMsg('regex','電話番号'),
    maxlength:getMsg('max.string', '電話番号', {'max' : 13}),
  };

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['customer_email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['customer_email'] = {
    required:getMsg('required','E-mailアドレス'),
    maxlength:getMsg('max.string', 'E-mailアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','E-mailアドレス'),
  };

  // 郵便番号
  rul['customer_zip_cd'] = {digits: true, maxlength: 7};
  msg['customer_zip_cd'] = {
    digits:getMsg('numeric','郵便番号'),
    maxlength:getMsg('single_bite_digits', '郵便番号',  {'digits' : '7桁の'}),
  };

  // 住所１
  // 指定のチェックボックスorラジオボタンにチェックがある場合必須
  rul['customer_address1'] = {
    required:{
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return $('#contact_way4').prop('checked');
    }},
    maxlength: 40
  };
  msg['customer_address1'] = {
    required:getMsg('required','住所1'),
    maxlength:getMsg('max.string', '住所1', {'max' : '40'}),
  };

  // 住所２
  rul['customer_address2'] = {
    required:{
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return $('#contact_way4').prop('checked');
    }},
    maxlength: 20
  };
  msg['customer_address2'] = {
    required:getMsg('required','住所2'),
    maxlength:getMsg('max.string', '住所2', {'max' : '20'}),
  };


  //////////////////////////////////
  //
  // 現在ご所有の物件について
  //
  //////////////////////////////////

  // 物件の種類
  rul['property_type'] = {
    required: {
      depends:function(){
        $(this).val(changeBlank($(this).val()));
        return true;
    }}
  };
  msg['property_type'] = {
    required:getMsg('required','物件の種類の選択'),
  };

  // マンション名
  rul['property_nm'] = {
    // required:{depends: function (element) {
    //     $(this).val(changeBlank($(this).val()));
    //     return $('#property_type3').prop('checked')
    // }},
    maxlength: 40};
  msg['property_nm'] = {
    // required:getMsg('required','マンション名'),
    maxlength:getMsg('max.string', 'マンション名', {'max' : '40'}),
  };

  // 部屋番号
  rul['property_room_no'] = {
    // required:{depends: function (element) {
    //     $(this).val(changeBlank($(this).val()));
    //     return $('#property_type3').prop('checked')
    // }},
    maxlength: 5};
  msg['property_room_no'] = {
    // required:getMsg('required','部屋番号'),
    maxlength:getMsg('max.string', '部屋番号', {'max' : '5'}),
  };


  //////////////////////////////////
  //
  // ご購入希望条件に付いて
  //
  //////////////////////////////////

  // 希望地域
  rul['cond_area_setting_kbn'] = {
    // required:{
    //   depends:function(){
    //     $(this).val(changeBlank($(this).val()));
    //     return true;
    // }},
    minlength: 1,
  };
  msg['cond_area_setting_kbn'] = {
    // required:getMsg('required','希望地域'),
    minlength:getMsg('required','希望地域'),
  };

  // 鉄道・沿線１
  // 指定のチェックボックスorラジオボタンにチェックがある場合必須
  rul['cond_railway_kbn_1'] = {required:{depends: '#cond_area_setting_kbn_1:checked'}};
  msg['cond_railway_kbn_1'] = {
    required:getMsg('required','鉄道会社・沿線'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが "" の場合
  rul['cond_railway_line_cd_1'] = {required: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway1').val() != ""; // 鉄道会社 がいずれか選択されている
      // b3 = $(element).val() == "" // 沿線 が未選択
      return b1 && b2;
  }}};
  msg['cond_railway_line_cd_1'] = {
    required:getMsg('required','沿線'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_from_1'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway1').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line1').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationTo1').val() != 0 // Toが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_from_1'] = {
    min:getMsg('required4'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_to_1'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway1').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line1').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationFrom1').val() != 0 // fromが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_to_1'] = {
    min:getMsg('required4'),
  };

  // 鉄道・沿線２
  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが "" の場合
  rul['cond_railway_line_cd_2'] = {required: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway2').val() != ""; // 鉄道会社 がいずれか選択されている
      return b1 && b2;
  }}};
  msg['cond_railway_line_cd_2'] = {
    required:getMsg('required','沿線'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_from_2'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway2').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line2').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationTo2').val() != 0 // Toが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_from_2'] = {
    min:getMsg('required4'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_to_2'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway2').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line2').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationFrom2').val() != 0 // fromが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_to_2'] = {
    min:getMsg('required4'),
  };

  // 鉄道・沿線３
  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが "" の場合
  rul['cond_railway_line_cd_3'] = {required: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway3').val() != ""; // 鉄道会社 がいずれか選択されている
      return b1 && b2;
  }}};
  msg['cond_railway_line_cd_3'] = {
    required:getMsg('required','沿線'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_from_3'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway3').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line3').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationTo3').val() != 0 // Toが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_from_3'] = {
    min:getMsg('required4'),
  };

  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_station_cd_to_3'] = {min: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_1').is(':checked'); // 希望地域 が ”沿線・駅から選択する” にチェック
      b2 = $('#railway3').val() != ""; // 鉄道会社 がいずれか選択されている
      b3 = $('#line3').val() != ""; // 沿線 がいずれか選択されている
      b4 = $('#stationFrom3').val() != 0 // fromが選択されている
      if (b1 && b2 && b3 && b4){
        return 1;
      } else {
        return 0;
      }
  }}};
  msg['cond_station_cd_to_3'] = {
    min:getMsg('required4'),
  };

  // エリア
  // 複数の条件が満たされたとき、requiredのバリデートを実行
  // 未選択のvalueが 0 の場合
  rul['cond_area_cd'] = {required: {
    depends: function (element) {
      b1 = $('#cond_area_setting_kbn_2').is(':checked'); // 希望地域 が ”エリアから選択する” にチェック
      return b1;
  }}};
  msg['cond_area_cd'] = {
    required:getMsg('required','エリア'),
  };

  // ご予算（下限）
  rul['cond_price_min'] = {digits_check_no: ["#cond_price_min", "#cond_price_max"],compare_number: ["#cond_price_min","#cond_price_max"]};
  msg['cond_price_min'] = {
    digits_check_no:getMsg('numeric', 'ご予算'),
    compare_number:getMsg('lt.numeric','ご予算（下限）', {'value' : 'ご予算（上限）'}),
  };

  // ご予算（上限）
  rul['cond_price_max'] = {digits_check_no: ["#cond_price_min", "#cond_price_max"],compare_number: ["#cond_price_min","#cond_price_max"]};
  msg['cond_price_max'] = {
    digits_check_no:getMsg('numeric', 'ご予算'),
    compare_number:getMsg('gt.numeric','ご予算（上限）',  {'value' : 'ご予算（下限）'}),
  };


  // 個人情報保護方針（プライバシー・ポリシー）
  rul['privacy_policy'] = {required: true,};
  msg['privacy_policy'] = {
    required:getMsg('required','個人情報保護方針（プライバシー・ポリシー）'),
  };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {

  // お客様情報
  $(".contact_way-group").on('change', function() {
    $("#contact_way1").valid();
  });
  $("#contact_way4").on('change', function() {
    $("#customer_address1").valid();
    $("#customer_address2").valid();
  });

  // 希望地域
  $('input[name="cond_area_setting_kbn"]').change(function() {
    $("#railway1").valid();
    $("#line1").valid();
    $("#stationFrom1").valid();
    $("#stationTo1").valid();
    $("#line2").valid();
    $("#stationFrom2").valid();
    $("#stationTo2").valid();
    $("#line3").valid();
    $("#stationFrom3").valid();
    $("#stationTo3").valid();
    $("#area").valid();
  });
  $("#railway1,#line1").change(function() {
    $("#railway1").valid();
    $("#line1").valid();
    $("#stationFrom1").valid();
    $("#stationTo1").valid();
  });
  $("#stationFrom1,#stationTo1").change(function() {
    $("#stationFrom1").valid();
    $("#stationTo1").valid();
  });
  $("#railway2,#line2").change(function() {
    $("#line2").valid();
    $("#stationFrom2").valid();
    $("#stationTo2").valid();
  });
  $("#stationFrom2,#stationTo2").change(function() {
    $("#stationFrom2").valid();
    $("#stationTo2").valid();
  });
  $("#railway3,#line3").change(function() {
    $("#line3").valid();
    $("#stationFrom3").valid();
    $("#stationTo3").valid();
  });
  $("#stationFrom3,#stationTo3").change(function() {
    $("#stationFrom3").valid();
    $("#stationTo3").valid();
  });
  $("#area").change(function() {
    $("#area").valid();
  });

  // 予算・希望面積
  $("#cond_price_min,#cond_price_max").on('blur', function() {
    $("#cond_price_min").valid();
    $("#cond_price_max").valid();
  });

}());
